module.exports = __webpack_public_path__ + "img/p2-23.7afc9fc9.png";